<template>
  <div class="page-bottom clearfix">
    <div class="fr">
      <el-pagination
        background
        :total="pageObj.total"
        :current-page="pageObj.current"
        :page-size="pageObj.size"
        :page-sizes="pageObj.sizeList"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="prev, pager, next, sizes, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pageObj: {
      type: Object,
      default() {
        return {
          current: 1,
          total: 50,
          size: 10,
          sizeList: [10, 15, 20, 25, 30],
        };
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handleSizeChange(pageSize) {
      this.$emit("handleSizeChange",pageSize);
    },
    handleCurrentChange(curPage) {
      this.$emit("handleCurrentChange",curPage);
    },
  },
};
</script>

<style lang="less" scoped>
.page-bottom {
  margin-top: 20px;
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: @theme-color;
    color: #fff;
  }
  /deep/.el-pagination__jump {
    margin-left: -2px;
  }
  /deep/.el-table td,
  .el-table th {
    padding: 10px 0px;
  }
}
</style>
